<template>
  <ul class="nav special-folders">
    <li
      v-for="folder in filteredFolders"
      class="nav-item closes-sidebar"
    >
      <router-link :to="{
        name: 'messages',
        params: {
          account: account.uuid,
          folder: folder.id,
        },
      }" class="nav-link">
        <i class="fas nav-icon" :class="folder.icon"></i>
      {{folder.label}}
      </router-link>
    </li>
    <li class="nav-item closes-sidebar">
      <a class="nav-link" href="#" @click="writeMessage">
        <i class="fas fa-pencil nav-icon"></i>
        Scrivi
      </a>
    </li>
  </ul>
</template>

<script setup>
import { computed, inject } from 'vue';
import { FOLDERS } from '@/services/message.service.js';
import * as messageService from '@/services/message.service';

const userCan = inject('userCan');
const props = defineProps(['account']);

const folders = [
  {
    id: FOLDERS.INBOX,
    label: "Ricevuta",
    icon: "fa-inbox",
    onlyPec: false,
  },
  {
    id: FOLDERS.SENT,
    label: "Inviata",
    icon: "fa-paper-plane",
    onlyPec: false,
  },
  {
    id: FOLDERS.RECEIPTS,
    label: "Notifiche",
    icon: "fa-clipboard-check",
    onlyPec: true,
  },
  {
    id: FOLDERS.DRAFTS,
    label: "Bozze",
    icon: "fa-file",
    onlyPec: false,
  },
  {
    id: FOLDERS.TRASH,
    label: "Cestino",
    icon: "fa-trash",
    onlyPec: false,
  },
];

const filteredFolders = computed(() => {
  return folders.filter((f) => !f.onlyPec || props.account.type === 'pec');
});

async function writeMessage() {
  const draft = await messageService.createDraft(props.account.uuid);
  window.open(
    `/messages/new?id=${draft.uuid}&account=${props.account.uuid}`,
    `Scrivi mail ${draft.uuid}`,
    "width=1000; height=700"
  );
}
</script>

<style scoped>
.special-folders {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
</style>
